import Globals from '../utilities/globals';

let mobileMediaQueryMatch;

// Part of the global nav
let secondaryNav;
// const mobileHeader = document.querySelector('.js-header--mobile');
let interiorNav;
let secondaryNavHeight;
// const mobileHeaderHeight = mobileHeader.offsetHeight;
// let interiorNavHeight;

// let scrollTopOffset;

function handleMediaQueryChange(e) {
  console.log('handleMediaQueryChange', e);
  // set the top nav distance for sticky nav.
  if (e.matches) {
    // mobile.
    // scrollTopOffset = mobileHeaderHeight + interiorNavHeight;
  } else {
    // desktop
    // scrollTopOffset = secondaryNavHeight + interiorNavHeight;
    interiorNav.style.top = `${secondaryNavHeight}px`;
  }
}

function init() {
  secondaryNav = document.querySelector('.js-secondary-nav');
  interiorNav = document.querySelector('.js-interior-nav');

  if (secondaryNav && interiorNav) {
    secondaryNavHeight = secondaryNav.offsetHeight;
    // interiorNavHeight = interiorNav.offsetHeight;

    // create media query for mobile
    mobileMediaQueryMatch = window.matchMedia(Globals.mediaQuery.mobile);

    // check if media query matches
    mobileMediaQueryMatch.addEventListener('change', handleMediaQueryChange);
    handleMediaQueryChange(mobileMediaQueryMatch); // Initial check

    // // Select all links with hashes
    // const links = document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"]):not([href="#main"])')
    // links.forEach(link => {
    //     link.addEventListener('click', function(event) {
    //       // On-page links
    //       if (
    //         location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
    //         location.hostname === this.hostname
    //       ) {
    //         // Figure out element to scroll to
    //         let target = document.querySelector(this.hash);
    //         target = target ? target : document.querySelector(`[name=${this.hash.slice(1)}]`);
    //         // Does a scroll target exist?
    //         if (target) {
    //           // Only prevent default if animation is actually gonna happen
    //           event.preventDefault();
    //           const scrollTopVal = target.getBoundingClientRect().top + window.pageYOffset - scrollTopOffset;
    //           window.scrollTo({
    //             top: scrollTopVal,
    //             behavior: 'smooth'
    //           });
    //           // Callback after animation
    //           target.focus();
    //           if (target !== document.activeElement) { // Checking if the target was focused
    //             target.setAttribute('tabindex', '-1'); // Adding tabindex for elements not focusable
    //             target.focus(); // Set focus again
    //           }
    //         }
    //       }
    //     });
    //   });
  }
}

function unload() {
  mobileMediaQueryMatch.removeEventListener('change', handleMediaQueryChange);
}

export default {
  init() {
    init();
  },
  unload() {
    unload();
  },
};
